/* eslint-disable i18next/no-literal-string */
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const PermissionErrorPage = () => {
  const RedirectToSupport = () => {
    window.open('https://support.expcloud.com/portal/en/newticket', '_blank');
  };

  return (
    <Box
      data-testid="permission-error-page"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <Box
        data-testid="permission-error-icon-container"
        sx={{
          backgroundColor: 'rgba(254, 226, 226, 0.6)',
          borderRadius: '50%',
          width: '70px',
          height: '70px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem',
        }}
      >
        <ErrorOutlineIcon
          sx={{ color: '#E53935', fontSize: '2rem' }}
          data-testid="permission-error-icon"
        />
      </Box>

      <Typography
        variant="h4"
        data-testid="permission-error-title"
        sx={{
          fontWeight: 600,
          fontSize: '2rem',
          marginBottom: '1.5rem',
          color: 'text.primary',
        }}
      >
        Access Restricted
      </Typography>

      <Stack
        spacing={1}
        sx={{ maxWidth: '500px', marginBottom: '2.5rem' }}
        data-testid="permission-error-messages"
      >
        <Typography
          variant="body1"
          data-testid="permission-error-message-1"
          sx={{
            fontSize: '1.1rem',
            fontWeight: 400,
            color: 'text.secondary',
            lineHeight: 1.5,
          }}
        >
          Your account doesn't currently have access to this feature.
        </Typography>
        <Typography
          variant="body1"
          data-testid="permission-error-message-2"
          sx={{
            fontSize: '1.1rem',
            fontWeight: 400,
            color: 'text.secondary',
            lineHeight: 1.5,
          }}
        >
          Please contact our support team for assistance or to request access.
        </Typography>
      </Stack>

      <Button
        variant="contained"
        onClick={RedirectToSupport}
        data-testid="contact-support-button"
        sx={{
          backgroundColor: '#000',
          color: '#fff',
          borderRadius: '2rem',
          padding: '0.75rem 2rem',
          textTransform: 'none',
          marginBottom: '2.5rem',
          fontSize: '0.95rem',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: '#333',
          },
        }}
      >
        Contact Support Team
      </Button>

      <Typography
        variant="body2"
        data-testid="permission-error-footer"
        sx={{
          fontSize: '0.9rem',
          color: 'text.secondary',
          fontWeight: 400,
        }}
      >
        If you believe this is an error, please refresh the page or try again
        later.
      </Typography>
    </Box>
  );
};

export default PermissionErrorPage;
